import React, { useState, useEffect, useRef } from "react";
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Avatar,
  Divider,
  IconButton,
  Input,
  Paper,
  Tooltip,
  Typography
} from '@material-ui/core';
import SendIcon from '@material-ui/icons/Send';
import AddPhotoIcon from '@material-ui/icons/AddPhotoAlternate';
import AttachFileIcon from '@material-ui/icons/AttachFile';
import { useSelector, useDispatch } from "react-redux";
import { Trans, useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'center'
  },
  paper: {
    flexGrow: 1,
    marginLeft: theme.spacing(2),
    padding: theme.spacing(0.5, 2)
  },
  input: {
    width: '100%'
  },
  divider: {
    width: 1,
    height: 24
  },
  fileInput: {
    display: 'none'
  }
}));

function CommentForm({ disabled, post, handleSubmit , className, ...rest }) {
  const classes = useStyles();
  const fileInputRef = useRef(null);
  const [value, setValue] = useState('');
  const [t, i18n] = useTranslation();
  const dispatch = useDispatch();

  const users = useSelector((state) => state.usersReducer);

  const [imageUrl, setImageUrl] = useState()

  useEffect(() => {
    if(!users.user) { return }

    setImageUrl(users.user.getProfilePicture() ? users.user.getProfilePicture().getUrl("thumbnail"):"")
  }, [users.user])

  const sender = {
    avatar: imageUrl
  };

  const handleChange = (event) => {
    event.persist();
    if (event.target.value.length < 1000) {
      setValue(event.target.value);
    }
  };

  const handleAttach = () => {
    fileInputRef.current.click();
  };

  const handleKeyUp = (event) => {
    if (event.keyCode === 13) {
      handleSubmit(value, users.user);
      setValue("");
    }
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Avatar
        alt="Person"
        src={sender.avatar}
      />
      <Paper
        className={classes.paper}
        elevation={1}
      >
        <Input
          className={classes.input}
          disableUnderline
          disabled={disabled || false}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
          placeholder={t("frontend.leaveComment")}
          value={value}
        />
      </Paper>
      <Tooltip title="Send">
        <IconButton 
          onClick={() => {
            handleSubmit(value, users.user);
            setValue("");
          }} 
          
          color={value.length > 0 && !disabled ? 'secondary' : 'default'}
          disabled={!value.replace(/\s/g, '').length || disabled}
        >
          <SendIcon />
        </IconButton>
      </Tooltip>
      {/* <Divider className={classes.divider} />
      <Tooltip title="Attach image">
        <IconButton
          edge="end"
          onClick={handleAttach}
        >
          <AddPhotoIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Attach file">
        <IconButton
          edge="end"
          onClick={handleAttach}
        >
          <AttachFileIcon />
        </IconButton>
      </Tooltip> */}
      <input
        className={classes.fileInput}
        ref={fileInputRef}
        type="file"
        disabled={disabled || false}
      />
    </div>
  );
}

CommentForm.propTypes = {
  className: PropTypes.string
};

export default CommentForm;
